import { render, staticRenderFns } from "./ticketEstudiante.vue?vue&type=template&id=b13257d6"
import script from "./ticketEstudiante.vue?vue&type=script&lang=js"
export * from "./ticketEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports